import React, { useState, useEffect } from 'react';
import './index.css';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import Services from './components/Services';
import About from './components/About';
import Connect from './components/Connect';

const validPages = ['hero', 'navigation', 'services', 'about', 'connect'];

function getPageFromHash() {
  const hash = window.location.hash.slice(1); // Remove the '#'
  return validPages.includes(hash) ? hash : 'navigation';
}

function getInitialPage() {
  const hash = window.location.hash.slice(1);
  // Only show hero video on refresh for navigation page (or no hash/hero)
  if (hash === '' || hash === 'hero' || hash === 'navigation') {
    return 'hero';
  }
  // For other pages, go directly to that page
  return validPages.includes(hash) ? hash : 'navigation';
}

function App() {
  const [currentPage, setCurrentPage] = useState(getInitialPage);
  const [destinationAfterHero] = useState('navigation');

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPage(getPageFromHash());
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const showPage = (pageName) => {
    window.location.hash = pageName;
    setCurrentPage(pageName);
  };

  return (
    <div className="App">
      <Hero
        onNavigate={showPage}
        isActive={currentPage === 'hero'}
        currentPage={currentPage}
        destinationAfterVideo={destinationAfterHero}
      />
      <Navigation 
        onNavigate={showPage}
        isActive={currentPage === 'navigation'}
        currentPage={currentPage}
      />
      <Services 
        onNavigate={showPage}
        isActive={currentPage === 'services'}
        currentPage={currentPage}
      />
      <About 
        onNavigate={showPage}
        isActive={currentPage === 'about'}
        currentPage={currentPage}
      />
      <Connect 
        onNavigate={showPage}
        isActive={currentPage === 'connect'}
        currentPage={currentPage}
      />
    </div>
  );
}

export default App;
